<!-- ══ Templates nav-left ══════════════════════════════════════════════════ -->

<!-- 1. Header : bouton retour -->
<ng-template #headerTpl>
  <app-button
    variant="tertiary"
    size="small"
    label="Area and sites"
    [addIconLeft]="true"
    (clicked)="router.navigate(['/area'])"
    data-attr="site-btn-back">
    <img slot="icon-left" src="assets/icon/new_icon/arrow-left.svg" alt="" aria-hidden="true" />
  </app-button>
</ng-template>

<!-- 2. Search + Blast + Filter -->
<ng-template #searchTpl>
  <div class="flex-row">
    <app-input class="site-toolbar__search" placeholder="Search" [clearable]="true" data-attr="site-input-search">
      <svg slot="icon-left" width="16" height="16">
          <use href="../../../assets/icon/new_icon/search.svg"></use>
      </svg>
    </app-input>
    <app-button variant="primary" color="amarante" label="Blast" [addIconLeft]="true" data-attr="site-btn-blast">
      <img slot="icon-left" src="assets/icon/new_icon/add_circle.svg" alt="" />
    </app-button>
    <div class="filter-popup-wrapper" #filterBtn>
      <app-button
        variant="secondary" color="amarante" size="small"
        [addLabel]="false" [addIconLeft]="true"
        (click)="openFilter(filterBtn)"
        [state]="filterOpen() ? 'pressed' : 'default'"
        [class.no-hover]="filterOpen()"
        data-attr="site-btn-filter">
        <img slot="icon-left" src="assets/icon/new_icon/filter.svg" alt="" />
        <img slot="icon-left-active" src="assets/icon/new_icon/filter_active.svg" alt="" />
      </app-button>
      <app-popup-panel
        [isOpen]="filterOpen()"
        [showHeader]="false"
        class="popup-panel-position"
        [ngStyle]="{ top: filterPopupPos().top, right: filterPopupPos().right }"
        (closed)="filterOpen.set(false)"
        [hidden]="!filterOpen()">

        <div class="grouping-panel">
          <div class="settings__field">
            <span class="settings__label">Level 1</span>
            <app-select
              [options]="optionsL1()"
              [ngModel]="pendingL1()"
              (selectionChange)="onL1Change($event)"
              placeholder="Select..."
              data-attr="site-select-level1">
            </app-select>
          </div>
          <div class="settings__field">
            <span class="settings__label">Level 2</span>
            <app-select
              [options]="optionsL2()"
              [ngModel]="pendingL2()"
              (selectionChange)="onL2Change($event)"
              placeholder="None"
              data-attr="site-select-level2">
            </app-select>
          </div>
          <div class="settings__field" [class.settings__field--disabled]="level3Disabled()">
            <span class="settings__label">Level 3</span>
            <app-select
              [options]="optionsL3()"
              [ngModel]="pendingL3()"
              (selectionChange)="onL3Change($event)"
              placeholder="None"
              data-attr="site-select-level3">
            </app-select>
          </div>
        </div>

        <app-button
          slot="footer"
          label="Confirm"
          variant="primary"
          color="mint"
          size="small"
          (clicked)="applyGrouping()"
          data-attr="site-btn-confirm">
        </app-button>

      </app-popup-panel>
    </div>
  </div>
</ng-template>

<!-- 3. Site card -->
<ng-template #siteCardTpl>
  <div
    class="site-card"
    [class.site-card--node-active]="!!navLeft.config().selectedNodeId"
    (click)="onSiteCardClick()"
    data-attr="site-card-site">
    <div class="site-card__bar"></div>
    <span class="site-card__name">{{ siteNav.siteName() }}</span>
  </div>
</ng-template>

<!-- ══ Templates actions page-bar ══════════════════════════════════════════ -->

<ng-template #pageBarSiteTpl>
  <app-button label="Projet" variant="secondary" color="amarante" [addIconLeft]="true" data-attr="site-btn-projet">
    <img slot="icon-left" src="assets/icon/new_icon/add_circle_black.svg" alt="" />
    <img slot="icon-left-active" src="assets/icon/new_icon/add_circle.svg" alt="" />
  </app-button>
  <app-button label="Report" variant="primary" color="amarante" [addIconLeft]="true" data-attr="site-btn-report-site">
    <img slot="icon-left" src="assets/icon/new_icon/report.svg" alt="" />
  </app-button>
  <app-button variant="tertiary" [addLabel]="false" [addIconLeft]="true" data-attr="site-btn-settings-site">
    <img slot="icon-left" src="assets/icon/new_icon/settings_black.svg" alt="" />
  </app-button>
</ng-template>

<ng-template #pageBarProjectTpl>
  <app-button label="Report" variant="primary" color="amarante" [addIconLeft]="true" data-attr="site-btn-report-project">
    <img slot="icon-left" src="assets/icon/new_icon/report.svg" alt="" />
  </app-button>
  <app-button variant="tertiary" [addLabel]="false" [addIconLeft]="true" data-attr="site-btn-settings-project">
    <img slot="icon-left" src="assets/icon/new_icon/settings_black.svg" alt="" />
  </app-button>
</ng-template>

<ng-template #pageBarNodeTpl>
  <app-button label="Report" variant="primary" color="amarante" [addIconLeft]="true" data-attr="site-btn-report-node">
    <img slot="icon-left" src="assets/icon/new_icon/report.svg" alt="" />
  </app-button>
  <app-button variant="tertiary" [addLabel]="false" [addIconLeft]="true" data-attr="site-btn-settings-node">
    <img slot="icon-left" src="assets/icon/new_icon/settings_black.svg" alt="" />
  </app-button>
</ng-template>

<ng-template #pageBarBlastTpl>
  <app-button label="Holes" variant="secondary" color="amarante" [addIconLeft]="true" data-attr="site-btn-holes">
    <img slot="icon-left" src="assets/icon/new_icon/add_circle_black.svg" alt="" />
    <img slot="icon-left-active" src="assets/icon/new_icon/add_circle.svg" alt="" />
  </app-button>
  <app-button label="Report" variant="primary" color="amarante" [addIconLeft]="true" data-attr="site-btn-report-blast">
    <img slot="icon-left" src="assets/icon/new_icon/report.svg" alt="" />
  </app-button>
  <app-button variant="tertiary" [addLabel]="false" [addIconLeft]="true" data-attr="site-btn-settings-blast">
    <img slot="icon-left" src="assets/icon/new_icon/settings_black.svg" alt="" />
  </app-button>
</ng-template>

<!-- ══ Contenu principal ════════════════════════════════════════════════════ -->

<div class="page-body">

  <!-- Carte Maps — instance unique, [hidden] selon écran + onglet actif -->
  <div
    class="page-body__map"
    [hidden]="activeScreen() === 'node' || pageBar.config().activeTabId !== 'maps'">
    <!-- TODO : <app-blast-map> à intégrer en second temps -->
    <div class="map-placeholder">Carte — à intégrer</div>
  </div>

  <!-- ── Écran SITE ───────────────────────────────────────────────────────── -->
  @if (activeScreen() === 'site' && pageBar.config().activeTabId === 'dashboard') {
    <app-site-dashboard [siteId]="siteNav.siteId()"></app-site-dashboard>
  }
  @if (activeScreen() === 'site' && pageBar.config().activeTabId === 'files') {
    <div class="page-body__content"><p>Files site — à implémenter</p></div>
  }
  @if (activeScreen() === 'site' && pageBar.config().activeTabId === 'measurement-point') {
    <div class="page-body__content"><p>Measurement point — à implémenter</p></div>
  }

  <!-- ── Écran PROJECT ────────────────────────────────────────────────────── -->
  <!-- @if (activeScreen() === 'project' && pageBar.config().activeTabId === 'dashboard') {
    <app-project-dashboard [projectId]="queryParams()!.projectId!" />
  }
  @if (activeScreen() === 'project' && pageBar.config().activeTabId === 'files') {
    <app-project-files [projectId]="queryParams()!.projectId!" />
  } -->

  <!-- ── Écran NODE ───────────────────────────────────────────────────────── -->
  <!-- @if (activeScreen() === 'node') {
    <app-node-dashboard
      [nodeType]="queryParams()!.nodeType!"
      [nodeValue]="queryParams()!.nodeValue!"
      [siteId]="siteNav.siteId()!" />
  } -->

  <!-- ── Écran BLAST ───────────────────────────────────────────────────────── -->
  <!-- @if (activeScreen() === 'blast' && pageBar.config().activeTabId === 'dashboard') {
    <app-blast-dashboard [blastId]="queryParams()!.blastId!" />
  }
  @if (activeScreen() === 'blast' && pageBar.config().activeTabId === 'files') {
    <app-blast-files [blastId]="queryParams()!.blastId!" />
  }
  @if (activeScreen() === 'blast' && pageBar.config().activeTabId === 'kpi') {
    <app-blast-kpi [blastId]="queryParams()!.blastId!" />
  }
  @if (activeScreen() === 'blast' && pageBar.config().activeTabId === 'design') {
    <app-blast-design [blastId]="queryParams()!.blastId!" />
  }
  @if (activeScreen() === 'blast' && pageBar.config().activeTabId === 'loading') {
    <app-blast-loading [blastId]="queryParams()!.blastId!" />
  }
  @if (activeScreen() === 'blast' && pageBar.config().activeTabId === 'fragmentation') {
    <app-blast-fragmentation [blastId]="queryParams()!.blastId!" />
  }
  @if (activeScreen() === 'blast' && pageBar.config().activeTabId === 'vibration') {
    <app-blast-vibration [blastId]="queryParams()!.blastId!" />
  }
  @if (activeScreen() === 'blast' && pageBar.config().activeTabId === 'environment') {
    <app-blast-environment [blastId]="queryParams()!.blastId!" />
  }
  @if (activeScreen() === 'blast' && pageBar.config().activeTabId === 'feedback') {
    <app-blast-feedback [blastId]="queryParams()!.blastId!" />
  } -->

</div>